import axios from "axios";

/**
 * Reduces an error to the fields that are safe to send to telemetry.
 *
 * An `AxiosError` serializes through `toJSON()` with its whole request config
 * attached — including the `x-access-token` header — so handing one straight to
 * `sentryLog` ships the session JWT to Sentry even when no token field is
 * passed explicitly (DEV-9694).
 */
export function describeErrorForLog(error: unknown): {
  errorName?: string;
  errorMessage: string;
  errorCode?: string;
  errorStatus?: number;
} {
  if (axios.isAxiosError(error)) {
    return {
      errorName: error.name,
      errorMessage: error.message,
      errorCode: error.code,
      errorStatus: error.response?.status,
    };
  }

  if (error instanceof Error) {
    return { errorName: error.name, errorMessage: error.message };
  }

  return { errorMessage: String(error) };
}
